import ClearIcon from '@mui/icons-material/Clear'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Tooltip,
} from '@mui/material'
import React from 'react'

type ModalProps = {
  open: boolean
  title: string
  onClose: () => void
  maxWidth: string
  Component: React.ReactNode
}

const HolidayModal: React.FC<ModalProps> = props => {
  const { open, title, onClose, Component, maxWidth } = props

  return (
    <Dialog
      fullWidth
      maxWidth={maxWidth as 'xs' | 'sm' | 'md' | 'lg' | 'xl'}
      open={open}
    >
      <DialogTitle
        component="h2"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 0,
        }}
        variant="h6"
      >
        {title}
        <Tooltip title="close">
          <IconButton onClick={onClose}>
            <ClearIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </DialogTitle>
      <DialogContent>{Component}</DialogContent>
    </Dialog>
  )
}

export default HolidayModal
